import React, { useEffect, useState } from 'react'
import { LuMapPin } from "react-icons/lu";
import { BsThreeDotsVertical } from "react-icons/bs";
import EditCalender from './EditCalender';
import EditNotes from './EditNotes';
import DeleteItem from './DeleteItem';
import Reschedule from './Reschedule';
import { getImages } from '../Const';

export default function CustomerWeekCalender({ leadData, leadAction, csLocation }) {
   // console.log("activeLocations Customer", activeLocations)
   // console.log("slots Customer", slots)
   // console.log("setappraisalData Customer", setappraisalData)
   // console.log("csLocation slots", slots)
   useEffect(() => {
      setPrevSlots(leadData);
   }, [leadData]);

   const [prevSlots, setPrevSlots] = useState(leadData);
   
   const [currentSlots, setCurrentSlots] = useState([]);

   /*
           {
            id: 46,
            start: new Date(2025, 1, 12, 14, 0),
            end: new Date(2025, 1, 12, 14, 0),
            location: "Pompano Beach",
            name: "Chris Turner",
            vehicle: "2020 Chevrolet Tahoe",
            phone: "+1 5614567890",
            notes: "Customer is considering a lease-to-own plan.",
            make: "Maserati",
            model: "Gran Turismo Sport",
            year: 2020,
            office: "Office",
            date: "01/19/25",
            timestamp: "02/07/2025 16:26:59",
            email: "chris.turner@example.com",
            dateOfSubmission: "02/07/2025",
            address: "123 Maserati Blvd, Boynton Beach, FL",
            vin: "1A2B3C4D5E6F7G8H9I",
            miles: "25,000",
            vehicleCondition: "Excellent",
            appraisalValue: "45000"
        },
   */

        var tzoffset = (new Date()).getTimezoneOffset() * 60000;

        const getNextFiveDays = () => {
         const today = new Date();
         const nextFive = [];
      
         for (let i = 0; i < 5; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            const iso = new Date(date - tzoffset).toISOString().split("T")[0];
            nextFive.push({
               date: iso,
               slots: [], // initialize empty, we will fill it later
            });

            //const date = new Date(today);
         }
      
         return nextFive;
      };

      const getLeadDays = () => {
         const today = new Date();
         const tzoffset = today.getTimezoneOffset() * 60000;
         const leadDays = [];
         if (!leadData || leadData.length === 0) {
            for (let i = 0; i < 5; i++) {
               const date = new Date(today);
               date.setDate(today.getDate() + i);
               const iso = new Date(date - tzoffset).toISOString().split("T")[0];
               leadDays.push({
               date: iso,
               slots: [],
               });
            }
            return leadDays;
         }
         const maxDate = leadData.reduce((prev,current) => {return (prev.callback_date_obj > current.callback_date_obj) ? prev : current});
       

         var date = new Date(today);
         var i = 0;
      
         while((date <= maxDate.callback_date_obj || i < 5) && i < 60) {    
            date = new Date(today);
            date.setDate(today.getDate() + i);
            const iso = new Date(date - tzoffset).toISOString().split("T")[0];
            leadDays.push({
               date: iso,
               slots: [], // initialize empty, we will fill it later
            });

            i++;
         }
      
         return leadDays;
      };
      


   const transformAppraisalData = (timeSlots) => {
      const leadDays = leadData ? getLeadDays() : getNextFiveDays();
   
      const groupedByDate = timeSlots.filter(lead => lead.callback_date_obj).reduce((acc, timeSlot) => {
         const today = new Date();
         const startDate = timeSlot.callback_date_obj < today ? today : timeSlot.callback_date_obj;
         const dateString = startDate.toISOString().split('T')[0];
         //const timeString = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

         //console.log(dateString,timeString);
   
         //const slot = { ...timeSlot, timeString };

         //console.log(timeSlot,startDate,dateString);

         const slot = { ...timeSlot };
   
         if (!acc[dateString]) {
            acc[dateString] = [];
         }
   
         acc[dateString].push(slot);
         return acc;
      }, {});
   
      const result = leadDays.map(day => {
         return {
            ...day,
            slots: groupedByDate[day.date] || day.slots, // keep default slot if no real data
         };
      });
   
      return result;
   };
   

   useEffect(() => {

      if (prevSlots) setCurrentSlots(transformAppraisalData(prevSlots));

   }, [prevSlots]);

   const CUSTOMDROPDOWN = ({ children, text }) => {
      const [open, setOpen] = useState(false);
      return <div className="btn-group calender-dropdown custom-dropdown ms-3 position-relative">
         <button onClick={() => setOpen(!open)} className="btn btn-secondary dropdown-toggle text-green" >
            {text}
         </button>
         <div className={`dropdown-menu dropdown-menu-custom dropdown-menu-end right-0 ${open ? "show" : ''}`}>
            {children}
         </div>
      </div>
   }

   const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
   ];

   const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
   ];

   const dayOfWeek = (date) => {
      const string = new Date(date);
      const dayOfWeek = daysOfWeek[string.getUTCDay()];
      return dayOfWeek;
   }
   const monthOfYear = (date) => {
      const string = new Date(date);
      const month = months[string.getUTCMonth()];
      return month;
   }
   const dayOfMonth = (date) => {
      const string = new Date(date);
      const dayOfMonth = string.getUTCDate();
      return dayOfMonth;
   }

   

   // useEffect(()=>{
   //    const today = new Date();
   //    const todayDayOfWeek = today.getDay();
   //    const weekStart = new Date(today);
   //    weekStart.setDate(today.getDate() - todayDayOfWeek);
   //    const weekDays = [];
   //    for (let i = 0; i < 7; i++) {
   //       const date = new Date(weekStart);
   //       date.setDate(weekStart.getDate() + i);
   //       weekDays.push(date);
   //    }
   //    const currentWeekDays = weekDays;
   //    const arr = [];
   //    currentWeekDays.forEach(date => {
   //       const string = new Date(date);
   //       const dayOfWeek = daysOfWeek[string.getDay()];
   //       const month = months[string.getMonth()];
   //       const dayOfMonth = string.getDate();
   //       arr.push({
   //          date: date.toDateString(),
   //          dayOfMonth: dayOfMonth,
   //          dayOfWeek: dayOfWeek,
   //          month: month,
   //          slots : null
   //       })
   //       console.log(); 
   //    });
   //    setCurrentWeek(arr);
   // },[]);
   return (
      <div className='calender-week'>
         {/* {console.log("currentSlots", currentSlots)} */}
         {currentSlots && currentSlots.map((item, index) => (
            <div className='daybox' key={index}>
               <div className="classbar">
                  <div className='left-d'>
                     <div className='month text-uppercase'>{monthOfYear(item.date)}</div>
                     <div className='day'>{dayOfMonth(item.date)}</div>
                  </div>
                  <div className='right-d'>
                     <div className='dayofweek'>{dayOfWeek(item.date)}</div>
                  </div>
               </div>

               <div className='timeslot'>
                  <div className='slot'></div>
                  <div className='dynmic-right'>
                     <div className='slot-item py-3 pe-3 thead'>
                        <div className='tableslots w-full'>
                           {/* {!csLocationHide && <p className='s-c1'>Location</p>} */}
                           <p className='s-c1'>Name</p>
                           <p className='s-c2 ps-2'>Vehicle</p>
                           <p className='s-c3 ps-1'>Phone</p>
                           <p className='s-c4 ps-1'>Appraisal</p>
                           <p className='s-c5 ps-1'>Notes</p>
                           <p className='s-c6'></p>
                        </div>
                     </div>
                  </div>
               </div>
               {item.slots && item.slots.map((slot, j) => (
                  <div className={`load d-flex ${slot.location == "POMPANO BEACH" ? 'pompano-beach' : 'boynton-beach'} timeslot mb-2`} key={j}>
                     <div className='slot text-white pt-3 ps-2'></div>
                     <div className='dynmic-right'>
                        <div
                           className={`slot-item p-3 ps-2 rounded-14  ${j % 2 === 0 ? 'even' : 'odd'}`}
                        >
                           <div className='tableslots text-white'>
                              <p className='s-c1'>{slot.full_name}</p>
                              <p className='s-c2'>{slot.vehicle_name}</p>
                              <p className='s-c3'>{slot.phone}</p>
                              <p className='s-c4'>${slot.appraisal}</p>
                              <p className='s-c5'>{slot.notes && slot.notes.reduce((s, note) => { return s + " " + note.note }, "")}</p>
                              <p className='s-c6'>
                                 <button onClick={() => leadAction(slot)} type="button" className="trans-search-btn">
                                    <img src={getImages(j % 2 === 0 ? "search.png" : "search.png")} alt="Search" />
                                 </button>
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         ))
         }
      </div>
   )
}
